"use client";

import { FC } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { MediaBannerHighlightProps, MediaBannerHighlightType } from "@/types";

import "./MediaBannerHighlight.css";
import MediaBannerHighlightCard from "./MediaBannerHighlightCard";

export interface Props {
  entry: MediaBannerHighlightProps;
}

const MediaBannerHighlight: FC<Props> = ({ entry, ...rest }) => {
  if (entry?.variant === MediaBannerHighlightType.BOXED_CAROUSEL) {
    return (
      <div className="relative">
        <Swiper
          slidesPerView={1}
          spaceBetween={22}
          pagination={{ type: "bullets", clickable: true, el: ".media-banner-highlight-pagination" }}
          autoHeight={false}
          watchSlidesProgress={true}
          modules={[Pagination]}
        >
          {entry.content.map((slide, i) => (
            <SwiperSlide className="" key={`media-banner-highlight-${i}`}>
              <MediaBannerHighlightCard
                boxAlignment={entry.boxAlignment}
                content={slide}
                type={entry.variant}
                wrappedText={entry.wrappedText}
                titleColor={entry.titleColor}
                cardbackGroundColor={entry.backgroundColor}
                cardbackGroundOpacity={entry.backgroundOpacity}
              />
            </SwiperSlide>
          ))}
          <div className="media-banner-highlight-pagination text-center w-full relative z-20 md:-mt-l mb-xxl"></div>
        </Swiper>
      </div>
    );
  }

  return (
    <MediaBannerHighlightCard
      boxAlignment={entry.boxAlignment}
      content={entry.content[0]}
      type={entry.variant}
      animation={entry.animation}
      wrappedText={entry.wrappedText}
      titleColor={entry.titleColor}
      cardbackGroundColor={entry.backgroundColor}
      cardbackGroundOpacity={entry.backgroundOpacity}
      {...rest}
    />
  );
};

export default MediaBannerHighlight;
